export const useSxStyles = () => {
  return {
    activeContent: {
      display: 'block',
      background: 'white',
      padding: '20px',
      width: '100%',
      height: '100%',
      overflow: 'auto',
    },
    buttonText: {
      margin: '0px 0px 0px 4px',
      color: '#336699',
    },
    buttonIcon: {
      color: '#336699',
      margin: '2px',
    },
    container: {
      border: '1px solid',
    },
    contentTabs: {
      border: 'solid 1px #D6D6D6',
      flexGrow: 1,
    },
    content: {
      display: 'none',
      background: 'white',
      padding: '10px',
      width: '100%',
      height: '100%',
      overflow: 'auto',
    },
    dialogClose: {
      float: 'right',
      color: '#05A4D8',
      paddingTop: '0px',
      paddingRight: '4px',
    },
    inputDiv: {
      height: '40px',
      padding: '2px',
    },
    historyButton: {
      height: '24px',
      display: 'inline-block',
      cursor: 'pointer',
      border: '1px solid #cccccc',
      borderRadius: '2px',
      fontSize: '14px',
      paddingRight: '2px',
      paddingLeft: '2px',
    },
    titleText: {
      color: '#05A4D8',
      paddingLeft: '8px',
    },
    titleIcon: {
      color: '#05A4D8',
      paddingLeft: '4px',
    },
    tabs: {
      padding: '10px',
      background: '#eaeaea',
      cursor: 'pointer',
      border: 'none',
      fontSize: '16px',
      fontWeight: 'bold',
      borderRadius: '4px 4px 0 0',
      marginRight: '6px',
      borderBottom: 'none',
      borderTop: '3px solid #eaeaea',
      textTransform: 'unset',
      color: 'unset',
    },
    activeTabs: {
      padding: '10px',
      background: 'white',
      marginBottom: '-1px',
      borderTop: '3px solid #05A4D8 !important',
      borderLeft: '1px solid #D6D6D6',
      borderRight: '1px solid #D6D6D6',
      borderBottom: '#ffffff 1px solid',
      marginRight: '6px',
      fontSize: '16px',
      fontWeight: 'bold',
      borderRadius: '4px 4px 0 0',
      textTransform: 'unset',
      color: 'unset',
    },
    titleDiv: {
      height: '60px',
      marginLeft: '-24px',
      marginRight: '-24px',
      marginTop: '-24px',
      border: 'none',
      borderTop: '10px solid #05A4D8',
      borderBottom: '2px solid #f2f2f5',
      padding: '12px 10px',
      background: '#fff',
      color: '#05A4D8',
    },
    dialogOverflow: {
      overflow: 'visible',
    },
    btnLeftMargin: {
      marginLeft: '5px',
    },
  };
};
